export default "/static/webpack/media/person.af2a2b41.svg";